import { FC } from 'react'
import { MenuStandardSlideOutMobileMenuFooter } from 'storefront-modules/layout/Menu/MenuStandard'
import useAppConfig from '#/src/custom/hooks/useAppConfig'

interface IMobileMenuSlideOutFooterProps {}

const MobileMenuSlideOutFooter: FC<IMobileMenuSlideOutFooterProps> = () => {
  const appConfig = useAppConfig()

  return <MenuStandardSlideOutMobileMenuFooter panelItems={appConfig.topNavPanel?.items} />
}

export default MobileMenuSlideOutFooter
